import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3864070053/src/portal-v2/src/client/components/page-loading.tsx");
